import React from 'react';
import { createUseStyles } from 'react-jss';

const styles = createUseStyles({
    container: { position: 'relative' },
    input: {
        opacity: 0,
        width: '100%',
        height: 0,
        position: 'absolute'
    }
});
interface ICustomSelect {
    onChange: Function;
    onBlur: Function;
    value: string;
    SelectComponent: any;
    required: boolean;
    isDisabled: boolean;
    isChanging: boolean;
}
const CustomSelect = ({
    onChange,
    onBlur,
    value,
    SelectComponent,
    required,
    isChanging,
    ...props
}: ICustomSelect) => {
    const classes = styles();
    const handleChange = (value: string[][], actionMeta: any) => {
        onChange(value, actionMeta);
    };

    return (
        <div className={classes.container}>
            <SelectComponent
                value={value}
                {...props}
                onChange={handleChange}
                ref={(input: any) => {
                    if (input != null && isChanging) {
                        input.focus();
                        input.blur();
                    }
                }}
                onBlur={onBlur}
                menuPlacement="auto"
                captureMenuScroll={false}
            />
            {required && (
                <input
                    className={classes.input}
                    tabIndex={-1}
                    autoComplete="off"
                    value={value}
                    required={required}
                />
            )}
        </div>
    );
};

export default CustomSelect;
